var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajesticonsCommentLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 6.66602H8.33333C7.44928 6.66602 6.60143 7.0172 5.97631 7.64233C5.35119 8.26745 5 9.11529 5 9.99935V34.9993L10.7783 30.666C11.3553 30.2333 12.0571 29.9993 12.7783 29.9993H31.6667C32.5507 29.9993 33.3986 29.6482 34.0237 29.023C34.6488 28.3979 35 27.5501 35 26.666V9.99935C35 9.11529 34.6488 8.26745 34.0237 7.64233C33.3986 7.0172 32.5507 6.66602 31.6667 6.66602Z",
    stroke: "black",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsCommentLine);
export default __webpack_public_path__ + "static/media/majesticons_comment-line.39cca2ecac7ee832f8e014aca54440fa.svg";
export { ForwardRef as ReactComponent };